export const DISCRIMINATORS = {
    LoadOne: "loadOne",
};
  